class ColorRGB {
    /**
     * r値
     */
    _r: number;

    /**
     * g値
     */
    _g: number;

    /**
     * b値
     */
    _b: number;

    /**
     * 色名
     */
    _name: string = '';

    /**
     * コンストラクタ
     * @param r r値
     * @param g g値
     * @param b b値
     */
    constructor(r: number, g: number, b: number) {
      this._r = r;
      this._g = g;
      this._b = b;
    }

    /**
     * 文字列化
     * 「rgb([r値],[g値],[b値])」を返却します。
     * @return rgb文字列
     */
    public toXmlString(): string {
      return `rgb(${this._r},${this._g},${this._b})`;
    }
}
export default ColorRGB;
